import React, { createContext, useState, useEffect } from 'react';
import firebase from '../firebase';

export const UserContext = createContext();

export default function UserProvider(props) {

    const [user, setUser] = useState({});
    
    useEffect(() => {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                console.log(user);
                setUser(user);
                console.log(user.displayName)
            } else {
                console.log('no user');
                setUser(null);
            }
        })
    }, [])

    return (
        <UserContext.Provider value={[user, setUser]}>
            {props.children}
        </UserContext.Provider>
    )

}